module.exports = __webpack_public_path__ + "img/BRCA3_CD8Tex.a0d572c0.png";